module.exports = __webpack_public_path__ + "img/logo.f4eec32b.png";